import React, { Fragment, useEffect } from 'react'
import { RulesTitle } from '../style'
import Button from '@components/button'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { GeneralSetting } from '@apis/index'

const RuleLists = ({ gameName }: { gameName: string }) => {
  const keyName = `admin-rule-${gameName.toLowerCase()}`
  return (
    <Fragment>
      <RulesTitle>Rules of Game</RulesTitle>
      <div
        style={{
          overflowY: 'scroll',
          display: 'flex',
          flexDirection: 'column',
          rowGap: '20px',
        }}
      >
        <List keyName={keyName} />
      </div>
    </Fragment>
  )
}

export default RuleLists

const List = ({ keyName }: { keyName: string }) => {
  const { data: adminrules } = useSelector(
    (state: RootState) => state.adminRules,
  )

  const fetchRules = async () => {
    await GeneralSetting.getByGroup({
      id: 'admin-rule',
      state: 'adminRules',
    })
  }

  useEffect(() => {
    fetchRules()
  }, [])

  const rule = adminrules.find((r) => r.key === keyName)
  // console.log(rule, 'hey')
  return (
    <div>
      {rule?.value ? (
        <div
          style={{ fontSize: '14px', lineHeight: '1.6' }}
          dangerouslySetInnerHTML={{ __html: rule.value }}
        />
      ) : (
        <p>No rules found.</p>
      )}
    </div>
  )
}
